import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ReactionGame.css";

const ReactionGame = () => {

  const navigate = useNavigate();

  const initialForm = () => ({
    name: "",
    email: localStorage.getItem("rg_email") || "",
    sex: "",
    phone: localStorage.getItem("rg_phone") || "",
    age: "",
  });

  const [formData] = useState(initialForm);

  const [circleColor, setCircleColor] = useState("red");
  const [reactionTime, setReactionTime] = useState(0);
  const [startTime, setStartTime] = useState(null);

  const [clickCount, setClickCount] = useState(0);
  const [wrongClickCount, setWrongClickCount] = useState(0);

  const [results, setResults] = useState([]);
  const [countdown, setCountdown] = useState(null);
  const [greenClicked, setGreenClicked] = useState(false);

  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);

  const [page, setPage] = useState("game");

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  /* START GAME */

  const startGame = () => {

    setCircleColor("red");
    setCountdown(null);
    setGreenClicked(false);

    setTimeout(() => {

      setCircleColor("green");
      setStartTime(performance.now());

    }, Math.random()*2000+1000);

  };

  useEffect(()=>{
    startGame();
  },[]);

  /* CLICK */

  const handleCircleClick = () => {

    if(circleColor==="green" && startTime && !greenClicked){

      setGreenClicked(true);

      const endTime = performance.now();
      const timeTaken = ((endTime-startTime)/1000).toFixed(3);

      setReactionTime(timeTaken);
      setClickCount(prev=>prev+1);
      setResults(prev=>[...prev,timeTaken]);

      setCountdown(5);

    } else {

      setWrongClickCount(prev=>prev+1);

    }

  };

  /* SAVE DATA */

  const saveGameData = useCallback(async()=>{

    try{

      await axios.post("/save",{
        ...formData,
        results,
        wrongClickCount
      });

    }catch(error){

      console.error("Save error:",error);

    }

  },[formData,results,wrongClickCount]);

  /* COUNTDOWN */

  useEffect(()=>{

    if(countdown!==null && countdown>0){

      const timer=setTimeout(()=>setCountdown(countdown-1),1000);
      return ()=>clearTimeout(timer);

    }

    else if(countdown===0){

      setCircleColor("red");

      if(clickCount<5){

        startGame();

      }else{

        setPage("result");
        saveGameData();

      }

    }

  },[countdown,clickCount,saveGameData]);

  /* VALID ATTEMPTS */

  const validAttempts = results
    .map(time=>Number(time))
    .filter(time=>time>=0.150 && time<=1);

  const currentAverage =
    validAttempts.length>0
      ? validAttempts.reduce((a,b)=>a+b,0)/validAttempts.length
      : null;

  /* FETCH LEADERBOARD */

  useEffect(() => {

  const fetchLeaderboard = async () => {

    try {

      const email = localStorage.getItem("rg_email");

      const res = await axios.get(`/api/leaderboard?email=${email}`);

      setLeaderboard(res.data.leaderboard || []);
      setUserRank(res.data.userRank);

    } catch (error) {

      console.error("Leaderboard fetch error:", error);

    }

  };

  fetchLeaderboard();

  const interval = setInterval(fetchLeaderboard, 2000);

  return () => clearInterval(interval);

}, []);
  const handleTryAgain = ()=>{

    setPage("game");

    setClickCount(0);
    setWrongClickCount(0);
    setReactionTime(0);
    setResults([]);
    setGreenClicked(false);

    startGame();

  };

  const handleExit = async()=>{

    await saveGameData();
    navigate("/reactiongame");

  };

  return(

    <div className="containerr">

      {page==="game" &&(

        <div className="game-containerr">

          <div
            className={`circler ${circleColor}`}
            onClick={handleCircleClick}
          ></div>

          <p className="reaction-timer">
            Reaction Time: {(reactionTime*1000).toFixed(0)} ms
          </p>

          {countdown!==null &&(
            <p className="countdownr">
              Countdown: {countdown}
            </p>
          )}

          <p className="wrong-clickr">
            Wrong Clicks: {wrongClickCount}
          </p>

        </div>

      )}

      {page==="result" &&(

        <div className="result-big-container">

          {/* LEADERBOARD */}

          <div className="leaderboard-box">

            <h3>Leaderboard</h3>

            <table className="leaderboard-table">

              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Best Reaction</th>
                  <th>Medal</th>
                </tr>
              </thead>

              <tbody>

                {leaderboard.slice(0,5).map((player,index)=>{

                  let medal="";

                  if(index===0) medal="🥇";
                  else if(index===1) medal="🥈";
                  else if(index===2) medal="🥉";

                  return(

                    <tr key={index}>
                      <td>{index+1}</td>
                      <td>{player.name}</td>
                      <td>{(player.bestPoints*1000).toFixed(0)} ms</td>
                      <td>{medal}</td>
                    </tr>

                  )

                })} 

              </tbody>

            </table>

            {userRank && (
            <div className="your-rank-box">

              <p><b>Your Rank:</b> {userRank.rank}</p>

              <p>
                <b>Avg Reaction:</b>{" "}
                {currentAverage
                  ? (currentAverage * 1000).toFixed(0) + " ms"
                  : "N/A"}
              </p>

              <p><b>Percentile:</b> {userRank.percentile}%</p>

            </div>
          )}

          </div>

          {/* USER RESULTS */}

          <div className="results-box">

            <h2>Your Attempts</h2>

            <ul>

              {results.map((time,index)=>(
                <li key={index}>
                  Attempt {index+1}: {(time*1000).toFixed(0)} ms
                </li>
              ))}

            </ul>

            <button
              onClick={handleTryAgain}
              className="try-again-buttonr"
            >
              Try Again
            </button>

            <button
              onClick={handleExit}
              className="exit-buttonr"
            >
              Exit
            </button>

          </div>

        </div>

      )}

    </div>

  );

};

export default ReactionGame;